import { DyTableColumn } from 'src/app/dynamic/model/dy-model';

export const TABLE_CONFIG_COLUMNS_PRE_PAYMENT: DyTableColumn[] = [
  // { dataKey: 'prePaymentId', label: 'ID', width: 100, type: 'number' },
  {
    dataKey: 'srno',
    label: '#',
    width: 100,
    type: 'number',
  },
  {
    dataKey: 'id',
    label: 'Transaction ID',
    width: 150,
    type: 'number',
  },
  {
    dataKey: 'createDate',
    label: 'Pre Payment Date',
    width: 200,
    type: 'date',
  },
  {
    dataKey: 'prePaymentAmount',
    label: 'Total Pre Payment Amt.',
    width: 150,
    type: 'currency',
  },
  {
    dataKey: 'prePaymentApplied',
    label: 'Pre Payment Applied',
    width: 150,
    type: 'currency',
  },
  {
    dataKey: 'remainingBalance',
    label: 'Remaining Balance',
    width: 150,
    type: 'currency',
  },
  {
    dataKey: 'cardType',
    label: 'Card Type',
    width: 200,
    type: 'text',
  },
  {
    dataKey: 'prePaymentAppliedOn',
    label: 'Pre Payment Applied On',
    width: 200,
    type: 'date',
  },
  {
    dataKey: 'receiptId',
    label: 'Receipt Id',
    width: 150,
    type: 'number',
  },
];
